export const version = 'kunde-v1.20.0-SNAPSHOT-61c8f583871436ab31a24a79ef70dede6ca55cbe';